import { faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import "../../FlightSelection.css";
import ItineraryBrandMob from "./ItineraryBrandMob";
import Translation from "i18next";

class ItineraryPartOfferMob extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFareOptions: false,
      itineraryPartBrand: this.props.itineraryPartBrand,
    };
  }
  parseTime = (minute) => {
    let hours = parseInt(minute / 60);
    let minutes = minute % 60;
    return <span>{hours + "hrs " + minutes + " mins"}</span>;
  };
  parseDate = (dateString) => {
    let options = {
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    let date = new Date(dateString);
    let newDate = date.toLocaleString("en-GB", options);
    return <span>{newDate}</span>;
  };
  thousands_separators = (num) => {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  };
  // renderStops(segments,stops)
  // {
  //   if(stops > 0)
  //   {
  //   return(
  //     <div>
  //     {
  //       segments.map((segment,key)=> <span key={key}>{(key !== 0) &&<span>{stops} <span>{stops > 1?"Stops":"Stop"}</span> {segment.origin}</span>}</span>)
  //     }
  //     </div>
  //   );
  //   }
  //   else{
  //     return(<span>Non-stop</span>)
  //   }
  // }
  renderStops(segments, stops) {
    if (stops > 0) {
      if (segments.length > 1) {
        return (
          <span>
            <span>
              {stops > 1
                ? stops + " " + Translation.t("stops")
                : stops + " " + Translation.t("stop")}
            </span>
          </span>
        );
      } else {
        return (
          <span>
            <span>
              {stops > 1
                ? stops + " " + Translation.t("stops")
                : stops + " " + Translation.t("stop")}
            </span>
            {segments.map((segment, index) => (
              <span key={index}>
                {segment.flight.stopAirports.map((airport, index2) => (
                  <span key={index2}>{" " + airport.airport}</span>
                ))}
              </span>
            ))}
          </span>
        );
      }
    } else {
      return <span>{Translation.t("non-stop")}</span>;
    }
  }
  showFareOptions = () => {
    this.setState({ showFareOptions: true });
  };

  hidFareOptions = () => {
    this.setState({ showFareOptions: false });
  };
  render() {
    return (
      <div
        className={
          "itinerary-part-offer-mob bg-white mt-" + this.props.marginTop
        }
      >
        {!this.state.showFareOptions && (
          <div onClick={() => this.showFareOptions()}>
            <div className="operating-flight-mob py-1">
              <Row>
                <Col className="mx-3">
                  <span>{this.props.index + 1}</span>
                </Col>
                <Col>
                  <div className="text-right pr-2 py-1">
                    <span></span>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="pt-2">
              <div className="text-center flight-city-duration-mob">
                <Row>
                  <Col>
                    <span className="font-weight-bold">
                      {
                        this.props.itineraryPartBrand.itineraryPart.segments[0]
                          .origin
                      }
                    </span>
                  </Col>
                  <Col xs={6}>
                    <span>
                      {this.parseTime(this.props.itineraryPartBrand.duration)}
                    </span>
                  </Col>
                  <Col>
                    <span className="font-weight-bold">
                      {
                        this.props.itineraryPartBrand.itineraryPart.segments[
                          this.props.itineraryPartBrand.itineraryPart.segments
                            .length - 1
                        ].destination
                      }
                    </span>
                  </Col>
                </Row>
              </div>
              <div className="text-center py-2">
                <Row>
                  <Col>
                    <span className="flight-time-mob">
                      {this.parseDate(this.props.itineraryPartBrand.departure)}
                    </span>
                  </Col>
                  <Col xs={2} sm={3} md={2} className="m-0 p-0">
                    <FontAwesomeIcon icon={faPlaneDeparture} />
                    {/* <span className="flight-separtor-dot"></span> */}
                  </Col>
                  <Col>
                    <span className="flight-time-mob">
                      {this.parseDate(this.props.itineraryPartBrand.arrival)}
                    </span>
                  </Col>
                </Row>
              </div>
              <div className="text-center">
                <Row>
                  <Col xs={3} sm={3} md={3}>
                    <span></span>
                  </Col>
                  <Col>
                    <span>
                      {this.renderStops(
                        this.props.itineraryPartBrand.itineraryPart.segments,
                        this.props.itineraryPartBrand.itineraryPart.stops
                      )}
                    </span>
                  </Col>
                  <Col xs={3} sm={3} md={3}>
                    <span></span>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="text-center fly-price-info-mob py-1">
              <Row>
                <Col></Col>
                {this.props.itineraryPartBrand.echeepPrice != "N/A" ? (
                  <Col xs={12} sm={12} className="float-right">
                    <div className="text-right py-1">
                      <span className="fly-price-mob">
                        {Translation.t("from")}{" "}
                        <span>
                          {this.thousands_separators(
                            this.props.itineraryPartBrand.echeepPrice
                          )}
                        </span>{" "}
                      </span>
                    </div>
                  </Col>
                ) : (
                  <Col xs={12} sm={12} className="float-right">
                    <div className="text-right py-1">
                      <span className="fly-price-mob">
                        {Translation.t("from")}{" "}
                        <span>
                          {this.thousands_separators(
                            this.props.itineraryPartBrand.bcheepPrice
                          )}
                        </span>{" "}
                      </span>
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        )}
        {this.state.showFareOptions && (
          <div id="HEADER">
            <ItineraryBrandMob
              onCloseClicked={this.hidFareOptions}
              selectFlight={this.props.selectFlight}
              brandOffers={this.props.itineraryPartBrand.brandOffers}
              echeepPrice={this.props.itineraryPartBrand.echeepPrice}
              bcheepPrice={this.props.itineraryPartBrand.bcheepPrice}
              itineraryPart={this.props.itineraryPartBrand.itineraryPart}
            />
          </div>
        )}
      </div>
    );
  }
}
export default ItineraryPartOfferMob;
